// src/design/forms/datepicker/calendar-engine/use-cases/nepali_date/get_weeks_in_month.ts
var e = (e) => Math.ceil((e.firstAdDayInBSMonth.getDay() + e.numberOfDaysInBSMonth) / 7) - 1;
export { e as get_weeks_in_month };

//# sourceMappingURL=get_weeks_in_month.js.map